import React from "react";
import { Ban, Undo2 } from "lucide-react";

export const ExcluirConsejoBtn = ({ cn, descripcion, excl, testid }) => {
  const on = excl.set.has(cn);
  return (
    <button type="button" onClick={(e) => { e.stopPropagation(); excl.toggle(cn, descripcion); }} data-testid={testid}
            title={on ? "Volver a contarlo como consejo" : "No contar como consejo (servicios como SPD)"}
            className={"inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap transition-colors " +
              (on ? "border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100" : "border-slate-200 text-slate-500 hover:border-red-300 hover:text-red-600")}>
      {on ? <><Undo2 size={10} /> Excluido · deshacer</> : <><Ban size={10} /> No es consejo</>}
    </button>
  );
};
